
interface Creator {
  id: string;
  username: string;
  avatar_url: string | null;
  bio: string | null;
  creator_type: string[] | null;
  nationality: string | null;
  recipes: { count: number }[];
}

interface CreatorsViewProps {
  creators: Creator[];
}

export const CreatorsView = ({ creators }: CreatorsViewProps) => {
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {creators?.map((creator) => (
        <div key={creator.id} className="bg-white rounded-lg shadow p-4">
          <a href={`/${creator.username.toLowerCase().replace(/\s+/g, '')}`} className="block">
            <div className="flex items-center space-x-4 mb-4">
              {creator.avatar_url ? (
                <img
                  src={creator.avatar_url}
                  alt={creator.username}
                  className="w-16 h-16 rounded-full object-cover select-none"
                  onContextMenu={handleContextMenu}
                  draggable="false"
                />
              ) : (
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center text-gray-500">
                  {creator.username.charAt(0).toUpperCase()}
                </div>
              )}
              <div>
                <h3 className="font-semibold text-lg">{creator.username}</h3>
                <p className="text-sm text-gray-500">
                  {creator.recipes[0]?.count || 0} recipes
                </p>
              </div>
            </div>
            {creator.bio && (
              <p className="text-gray-600 text-sm line-clamp-3 mb-2">{creator.bio}</p>
            )}
            <div className="flex flex-wrap gap-2">
              {creator.creator_type && creator.creator_type.map((type) => (
                <span 
                  key={type} 
                  className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full"
                >
                  {type}
                </span>
              ))}
              {creator.nationality && (
                <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full">
                  {creator.nationality}
                </span>
              )}
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

